import type { ColumnDef } from '@tanstack/react-table';
import { DataTableColumnHeader } from '@/components/DataTable';
import { ContractStatus, ContractStatusBadge } from '@/features/contract/components/ContractStatusBadge';
import { ContractTableColumns } from '../../-constants';
type Item = {
  contractId: string;
  contractStatus: ContractStatus;
  contractStatusLabel: string;
};
export function contractStatusColumn<T extends Item>(): ColumnDef<T> {
  return {
    accessorKey: ContractTableColumns.contractStatus,
    meta: {
      i18nKey: 'contractStatus',
      thStyle: {
        minWidth: '150px'
      }
    },
    enableSorting: true,
    header: DataTableColumnHeader,
    cell: ({
      row
    }) => <ContractStatusBadge status={row.original.contractStatus} statusLabel={row.original.contractStatusLabel} showIcon={false} />
  };
}